import { Button, Card, CardContent, Grid, TextareaAutosize, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { FormSectionHeader } from "../../Shared/FormSectionHeader";

export const DispatchReadyActions = (
    allowed: boolean,
    callback: (() => void) | undefined,
    closeCallback: ((cancellationReason?: string) => void),
    collectedBy: string,
    setCollectedBy: (v: string) => void
) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [cancellationReason, setCancellationReason] = useState<string>("");

    const onClose = (cancellationReason?: string) => {
        setLoading(true);
        if (closeCallback)
            closeCallback(cancellationReason);
    };

    return (<Card>
        <FormSectionHeader label="Collection" />

        {allowed ?
            <CardContent>
                <Typography variant="subtitle1">
                    Once material has been collected for dispatch you can mark the request as collected. If materials are not expected to be returned, this will also close the dispatch request.
                </Typography>
                {callback === undefined &&
                    <Typography variant="subtitle1">
                        You must upload a signed dispatch note before the dispatch request can be set to 'Collected'.
                    </Typography>}
                {/*<Grid container mb={2}>*/}
                {/*    <Grid item xs={4} >*/}

                {/*    </Grid>*/}
                {/*</Grid>*/}


                <Grid container>
                    <Grid xs={10} item>
                        <TextField
                            fullWidth
                            required
                            variant="outlined"
                            label="Collected By"
                            value={collectedBy}
                            onChange={(e) => setCollectedBy(e.currentTarget.value)}
                            helperText="Courier / Haulage Company / Collected By / Disposed By" />
                    </Grid>
                    <Grid xs={2} container alignItems="center" justifyContent="right" item>
                        <Button variant="contained" onClick={callback ? () => callback() : undefined} disabled={callback === undefined || collectedBy.length < 1}>
                            Collected
                        </Button>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid xs={10} item>
                        <Typography variant="subtitle2">Cancel Dispatch Request</Typography>
                        <TextareaAutosize
                            placeholder="Enter a Cancellation Reason"
                            minRows={2}
                            style={{
                                borderRadius: '5px',
                                borderColor: '#ccc',
                                minWidth: '620px',
                                padding: '.5em'
                            }}
                            value={cancellationReason}
                            onChange={(e) => setCancellationReason(e.target.value)} />
                    </Grid>
                    <Grid xs={2} container alignItems="center" justifyContent="right" item>
                        <Button
                            variant="contained"
                            color="warning"
                            onClick={() => onClose(cancellationReason)}
                            disabled={loading || cancellationReason.length < 1}>Cancel</Button>
                    </Grid>
                </Grid>
            </CardContent>
            :
            <CardContent>
                <Typography variant="subtitle1">
                    This dispatch request is awaiting collection. There are currently no further actions available.
                </Typography>
            </CardContent>}
    </Card>);
};
